import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import PostPlaceholder from "./components/PostPlaceholder";
import SidebarNews from "./components/SidebarNews";
import * as Icon from "react-bootstrap-icons";
import PostContent from "./components/PostContent";
import Services from "../home/components/Services";
import { useSelector } from "react-redux";

const Post = () => {
  const [post, setPost] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const lang = useSelector((state) => state.mainSlice.lang);
  const [error, setError] = useState(null);
  const params = useParams();

  const fetchPost = () => {
    setIsLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/posts/post-detail/${params.slug}`
      )
      .then((res) => {
        setPost(res.data);
      })
      .then(() => {
        setIsLoading(false);
      })
      .catch((error) => {
        if (error.code === "ERR_NETWORK") {
          setError({
            en: "Network error!",
            ru: "Ошибка сети!",
            tm: "Tor ýalňyşlygy!",
          });
        } else if (error.response["status"] === 404) {
          setError({
            en: "News not found!",
            ru: "Новости не найдены!",
            tm: "Täzelik tapylmady!",
          });
        } else {
          setError({
            en: "Something went wrong!",
            ru: "Что-то пошло не так!",
            tm: "Käbir ýalňyşlyk ýüze çykdy!",
          });
        }
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    setPost(null);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/posts/post-detail/${params.slug}`
      )
      .then((res) => {
        setPost(res.data);
      })
      .then(() => {
        setIsLoading(false);
      })
      .catch((error) => {
        if (error.code === "ERR_NETWORK") {
          setError({
            en: "Network error!",
            ru: "Ошибка сети!",
            tm: "Tor ýalňyşlygy!",
          });
        } else if (error.response["status"] === 404) {
          setError({
            en: "News not found!",
            ru: "Новости не найдены!",
            tm: "Täzelik tapylmady!",
          });
        } else {
          setError({
            en: "Something went wrong!",
            ru: "Что-то пошло не так!",
            tm: "Käbir ýalňyşlyk ýüze çykdy!",
          });
        }
        setIsLoading(false);
      });
  }, [params]);

  return (
    <div className="post-page pt-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
            {isLoading === true ? (
              <PostPlaceholder />
            ) : error !== null ? (
              <div className="not-found">
                <h6>{error[lang]}</h6>
                <button className="clear-btn">
                  <Icon.ArrowClockwise onClick={() => fetchPost()} />
                </button>
              </div>
            ) : lang === "en" ? (
              post.name_en !== null && post.name_en !== "" ? (
                <PostContent post={post} />
              ) : (
                <p>No translation in English</p>
              )
            ) : lang === "ru" ? (
              post.name_ru !== null && post.name_ru !== "" ? (
                <PostContent post={post} />
              ) : (
                <p>Нет перевода на русский</p>
              )
            ) : (
              <PostContent post={post} />
            )}
          </div>
          <SidebarNews />
        </div>
      </div>
      <Services />
    </div>
  );
};

export default Post;
